import { ElementType } from 'react';
import { HeadlineProps } from '@/components/headline/types';
import { convertToSlug } from '@/utils/slugify';
import clsx from 'clsx';
import { renameDomProps } from '@/utils/sanitizeDomProps';
import { variantClasses, spacingClasses } from './const';

const headingLevels = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] as const;

export function Headline({
  level = 'h1',
  variant = 'headingOne',
  spacing = 'medium',
  className,
  title,
  sectionId,
  ...rest
}: HeadlineProps) {
  const resolvedVariantClasses =
    variantClasses[variant] || variantClasses['headingOne'];
  const resolvedSpacingClasses = spacingClasses[spacing] || 'my-4';

  const headlineClass = clsx(
    'smzh-headline',
    resolvedVariantClasses,
    resolvedSpacingClasses,
    className,
  );

  const slug = title ? convertToSlug(title) : undefined;

  const HeadingTag: ElementType = headingLevels.includes(level as any)
    ? level
    : 'h1';
  const renamedProps = renameDomProps(rest);
  return (
    <HeadingTag
      id={slug}
      data-component-id="C005"
      className={headlineClass}
      {...renamedProps}
    >
      {title}
    </HeadingTag>
  );
}
